module.exports = __webpack_public_path__ + "img/livemap_editbeacons.de746c3e.png";